import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';

import gql from 'graphql-tag';
import { PVInstallation } from '../../graphql/graphql.schema';
import { extractCustomersFromPV } from '../customers/customersList/customerExtractor';
import PendingActivationCustomersListView from './PendingActivationCustomersListView';

export const GET_CURRENT_PRO_USER_PENDING_CUSTOMERS = gql`
  query pvInstallationsActivationPending {
    pvInstallationsActivationPending {
      id
      panelCount
      panelWattPeak
      srsRegistrationDate
      srsRegistrationStatus
      tenant {
        name
      }
      customers {
        id
        lastName
        email
        firstName
        lastName
        address
        city
        zipCode
        country
        creationDate
        latitude
        longitude
      }
    }
  }
`;

interface IResponse {
  pvInstallationsActivationPending: [PVInstallation];
}

const PendingCustomersActivationListQuery = () => {
  return (
    <Query
      query={GET_CURRENT_PRO_USER_PENDING_CUSTOMERS}
      fetchPolicy={'no-cache'}
    >
      {({ loading, data, error }: QueryResult<IResponse>) => {
        const customers =
          data && data.pvInstallationsActivationPending
            ? extractCustomersFromPV(data.pvInstallationsActivationPending)
            : [];
        return (
          <PendingActivationCustomersListView
            customers={customers}
            loading={loading}
            error={error ? error.message : undefined}
          />
        );
      }}
    </Query>
  );
};

export default PendingCustomersActivationListQuery;
